var _regeneratorRuntime = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _slicedToArray = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _asyncToGenerator = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var Url = require('url');

var path = require("path");

var Headers = require('node-fetch').Headers;

var Readable = require('stream').Readable;

var contentTypeLookup = require('mime-types').contentType;

var SolidRest =
/*#__PURE__*/
function () {
  "use strict";

  function SolidRest(handlers) {
    var _this = this;

    _classCallCheck(this, SolidRest);

    this.storageHandlers = {};
    handlers.forEach(function (handler) {
      _this.storageHandlers[handler.prefix] = handler;
    });
    this.statusText = {
      200: "OK",
      201: "Created",
      400: "slashes not allowed in filenames",
      404: "Not Found",
      405: "Method Not Supported",
      409: "Conflict",
      500: "Internal Server Error"
    };
  }

  _createClass(SolidRest, [{
    key: "storage",
    value: function storage(options) {
      if (!this.storageHandlers[options.rest_prefix]) throw "Did not recognize prefix " + options.rest_prefix;
      return this.storageHandlers[options.rest_prefix];
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(uri, options) {
        var self, pathname, scheme, prefix, _ref, _ref2, objectType, objectExists, contents, link, slug, res, _response, _text, _text2, _json, _json2, _makeStream, _container2turtle, _container2turtle2, _getHeaders;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _getHeaders = function _ref13(pathname, options) {
                  var fn = pathname.replace(/.*\//, '');
                  var headers = typeof self.storage(options).getHeaders != "undefined" ? self.storage(options).getHeaders(pathname, options) : {};
                  headers.location = headers.location || options.uri;
                  headers.date = headers.date || new Date(Date.now()).toISOString();
                  headers.allow = headers.allow || ['OPTIONS, HEAD, GET, PATCH, POST, PUT, DELETE'];
                  headers['x-powered-by'] = headers['x-powered-by'] || self.storage(options).name;
                  headers.link = headers.link || options.objectType === "Container" ? "<.meta>; rel=\"describedBy\", <.acl>; rel=\"acl\"," + "<http://www.w3.org/ns/ldp#Container>; rel=\"type\"," + "<http://www.w3.org/ns/ldp#BasicContainer>; rel=\"type\"" : "<".concat(fn, ".meta>; rel=\"describedBy\", <").concat(fn, ".acl>; rel=\"acl\",") + "<http://www.w3.org/ns/ldp#Resource>; rel=\"type\"";
                  headers['content-type'] = headers['content-type'] || options.objectType === "Container" ? "text/turtle" : contentTypeLookup(path.extname(pathname));
                  return headers;
                };

                _container2turtle2 = function _ref12() {
                  _container2turtle2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(pathname, options, contentsArray) {
                    var filenames, folder, str2, str, i, fn, _ref3, _ref4, ftype, e;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(typeof self.storage(options).container2turtle != "undefined")) {
                              _context3.next = 2;
                              break;
                            }

                            return _context3.abrupt("return", self.storage(options).container2turtle(pathname, options, contentsArray));

                          case 2:
                            filenames = contentsArray.filter(function (item) {
                              if (!item.endsWith('.acl') && !item.endsWith('.meta')) {
                                return item;
                              }
                            });
                            folder = options.uri;
                            if (!folder.endsWith("/")) folder = folder + "/";
                            str2 = "";
                            str = "@prefix ldp: <http://www.w3.org/ns/ldp#>.\n" + "<> a ldp:BasicContainer, ldp:Container";

                            if (!filenames.length) {
                              _context3.next = 26;
                              break;
                            }

                            str = str + "; ldp:contains\n";
                            i = 0;

                          case 10:
                            if (!(i < filenames.length)) {
                              _context3.next = 25;
                              break;
                            }

                            fn = filenames[i];
                            _context3.next = 14;
                            return self.storage(options).getObjectType(pathname + fn);

                          case 14:
                            _ref3 = _context3.sent;
                            _ref4 = _slicedToArray(_ref3, 2);
                            ftype = _ref4[0];
                            e = _ref4[1];
                            if (ftype === "Container") fn = fn + "/"; //        let prefix = options.rest_prefix==="file" ? "" : options.rest_prefix
                            //        fn = options.scheme+"//"+prefix+pathname + fn

                            str = str + "  <".concat(fn, ">,\n");
                            ftype = ftype === "Container" ? "a ldp:Container; a ldp:BasicContainer." : "a ldp:Resource.";
                            str2 = str2 + "  <".concat(fn, "> ").concat(ftype, "\n");

                          case 22:
                            i++;
                            _context3.next = 10;
                            break;

                          case 25:
                            str = str.replace(/,\n$/, "");

                          case 26:
                            str = str + ".\n" + str2; // str = _makeStream(str);

                            return _context3.abrupt("return", [200, str]);

                          case 28:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));
                  return _container2turtle2.apply(this, arguments);
                };

                _container2turtle = function _ref11(_x7, _x8, _x9) {
                  return _container2turtle2.apply(this, arguments);
                };

                _makeStream = function _ref10(text) {
                  var s = new Readable();
                  s.push(text);
                  s.push(null);
                  return s;
                };

                _json2 = function _ref9() {
                  _json2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(stream, options) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(typeof self.storage(options).json != "undefined")) {
                              _context2.next = 4;
                              break;
                            }

                            return _context2.abrupt("return", self.storage(options).json(stream));

                          case 4:
                            return _context2.abrupt("return", JSON.parse(stream));

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                  return _json2.apply(this, arguments);
                };

                _json = function _ref8(_x5, _x6) {
                  return _json2.apply(this, arguments);
                };

                _text2 = function _ref7() {
                  _text2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(stream, options) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(typeof self.storage(options).text != "undefined")) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt("return", self.storage(options).text(stream));

                          case 4:
                            return _context.abrupt("return", stream);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                  return _text2.apply(this, arguments);
                };

                _text = function _ref6(_x3, _x4) {
                  return _text2.apply(this, arguments);
                };

                _response = function _ref5(response, options) {
                  var _response2 = _slicedToArray(response, 3),
                      status = _response2[0],
                      body = _response2[1],
                      headers = _response2[2];

                  headers = headers || _getHeaders(pathname, options);
                  return {
                    status: status,
                    ok: status >= 200 && status <= 299,
                    statusText: self.statusText[status],
                    headers: new Headers(headers),
                    body: body,
                    text: _text.bind(null, body, options),
                    json: _json.bind(null, body, options)
                  };
                };

                self = this;
                options = options || {};
                options.headers = options.headers || {};
                options.uri = decodeURIComponent(uri);
                pathname = decodeURIComponent(Url.parse(uri).pathname);
                options.method = (options.method || options.Method || 'GET').toUpperCase();
                scheme = Url.parse(uri).protocol;
                prefix = scheme.match("file") ? 'file' : uri.replace(scheme + '//', '').replace(/\/.*/, '');
                options.scheme = scheme;
                options.rest_prefix = prefix;
                _context4.next = 21;
                return self.storage(options).getObjectType(pathname, options);

              case 21:
                _ref = _context4.sent;
                _ref2 = _slicedToArray(_ref, 2);
                objectType = _ref2[0];
                objectExists = _ref2[1];
                options.objectType = objectType;
                options.objectExists = objectExists;
                /* GET
                */

                if (!(options.method === 'GET')) {
                  _context4.next = 47;
                  break;
                }

                if (objectExists) {
                  _context4.next = 30;
                  break;
                }

                return _context4.abrupt("return", _response([404], options));

              case 30:
                if (!(objectType === "Container")) {
                  _context4.next = 40;
                  break;
                }

                _context4.next = 33;
                return self.storage(options).getContainer(pathname, options);

              case 33:
                contents = _context4.sent;
                _context4.next = 36;
                return _container2turtle(pathname, options, contents);

              case 36:
                contents = _context4.sent;
                return _context4.abrupt("return", _response(contents, options));

              case 40:
                if (!(objectType === "Resource")) {
                  _context4.next = 47;
                  break;
                }

                _context4.t0 = _response;
                _context4.next = 44;
                return self.storage(options).getResource(pathname, options);

              case 44:
                _context4.t1 = _context4.sent;
                _context4.t2 = options;
                return _context4.abrupt("return", (0, _context4.t0)(_context4.t1, _context4.t2));

              case 47:
                if (!(options.method === 'HEAD')) {
                  _context4.next = 53;
                  break;
                }

                if (objectExists) {
                  _context4.next = 52;
                  break;
                }

                return _context4.abrupt("return", _response([404], options));

              case 52:
                return _context4.abrupt("return", _response([200], options));

              case 53:
                if (!(options.method === "DELETE")) {
                  _context4.next = 78;
                  break;
                }

                if (objectExists) {
                  _context4.next = 56;
                  break;
                }

                return _context4.abrupt("return", _response([404], options));

              case 56:
                if (!(objectType === "Container")) {
                  _context4.next = 67;
                  break;
                }

                _context4.t3 = Promise;
                _context4.t4 = _response;
                _context4.next = 61;
                return self.storage(options).deleteContainer(pathname, options);

              case 61:
                _context4.t5 = _context4.sent;
                _context4.t6 = options;
                _context4.t7 = (0, _context4.t4)(_context4.t5, _context4.t6);
                return _context4.abrupt("return", _context4.t3.resolve.call(_context4.t3, _context4.t7));

              case 67:
                if (!(objectType === 'Resource')) {
                  _context4.next = 78;
                  break;
                }

                _context4.t8 = Promise;
                _context4.t9 = _response;
                _context4.next = 72;
                return self.storage(options).deleteResource(pathname, options);

              case 72:
                _context4.t10 = _context4.sent;
                _context4.t11 = options;
                _context4.t12 = (0, _context4.t9)(_context4.t10, _context4.t11);
                return _context4.abrupt("return", _context4.t8.resolve.call(_context4.t8, _context4.t12));

              case 78:
                if (!(options.method === "POST")) {
                  _context4.next = 104;
                  break;
                }

                if (objectExists) {
                  _context4.next = 81;
                  break;
                }

                return _context4.abrupt("return", _response([404], options));

              case 81:
                link = options.headers.Link || options.headers.link;
                slug = options.headers.Slug || options.headers.slug;

                if (!slug.match(/\//)) {
                  _context4.next = 85;
                  break;
                }

                return _context4.abrupt("return", _response([400], options));

              case 85:
                pathname = path.join(pathname, slug);

                if (!(link && link.match("Container"))) {
                  _context4.next = 97;
                  break;
                }

                _context4.t13 = Promise;
                _context4.t14 = _response;
                _context4.next = 91;
                return self.storage(options).postContainer(pathname, options);

              case 91:
                _context4.t15 = _context4.sent;
                _context4.t16 = options;
                _context4.t17 = (0, _context4.t14)(_context4.t15, _context4.t16);
                return _context4.abrupt("return", _context4.t13.resolve.call(_context4.t13, _context4.t17));

              case 97:
                if (!(link && link.match("Resource"))) {
                  _context4.next = 104;
                  break;
                }

                _context4.t18 = _response;
                _context4.next = 101;
                return self.storage(options).putResource(pathname, options);

              case 101:
                _context4.t19 = _context4.sent;
                _context4.t20 = options;
                return _context4.abrupt("return", (0, _context4.t18)(_context4.t19, _context4.t20));

              case 104:
                if (!(options.method === 'PUT')) {
                  _context4.next = 122;
                  break;
                }

                if (!(objectType === "Container")) {
                  _context4.next = 107;
                  break;
                }

                return _context4.abrupt("return", Promise.resolve(_response([409], options)));

              case 107:
                _context4.next = 109;
                return self.storage(options).makeContainers(pathname, options);

              case 109:
                res = _context4.sent;

                if (!(!res == 200 && !res == 201)) {
                  _context4.next = 112;
                  break;
                }

                return _context4.abrupt("return", Promise.resolve(_response([res], options)));

              case 112:
                _context4.t21 = Promise;
                _context4.t22 = _response;
                _context4.next = 116;
                return self.storage(options).putResource(pathname, options);

              case 116:
                _context4.t23 = _context4.sent;
                _context4.t24 = options;
                _context4.t25 = (0, _context4.t22)(_context4.t23, _context4.t24);
                return _context4.abrupt("return", _context4.t21.resolve.call(_context4.t21, _context4.t25));

              case 122:
                return _context4.abrupt("return", Promise.resolve(_response([405], options)));

              case 123:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }() // end of fetch()

  }]);

  return SolidRest;
}(); // end of SolidRest()


module.exports = exports = SolidRest;
/* END */

/*
required
  getObjectType
  getResouce
  getContainer
  putResource
  postResource
  postContainer
  deleteResource
  deleteContainer
  makeContainers
optional
  getHeaders
  text
  json
*/